import Swal from "sweetalert2";
import Vue from "vue";
import { utils } from "./utils";
import { responses } from "./responses";
import { errorHandler } from "./errorHandler";
import queryStringify from "qs-stringify";
import TimeManager from "@/Services/TimeManager";
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import axios from "axios";
import { Storage } from "@/Services/Storage";

Vue.use(VueGoodTablePlugin);

// window.wareHouseTomcatApiC = `http://Self:8011/WarehouseManager/`
// window.backOfficeTomcatApi = `http://localhost:8080/Lyt-SoftBackOfficeApi/`
// window.franchiseTomcatApi = `http://localhost:8080/Franchise_OnlineServer/`

window.lytSIApi = "https://lna.pos.co.zm/lytSI/api/v1/";
window.syncingServer = `https://lna.pos.co.zm/syncServer/`;
window.laravelApi = `https://chrilantech.com/LytSoftPosOnline/api/`;
window.wareHouseTomcatApiC = `https://lna.pos.co.zm/WarehouseManager/`;
window.backOfficeTomcatApi =
  "https://overflow.pos.co.zm/Lyt-SoftBackOfficeApi/";
window.franchiseTomcatApi =
  "https://overflow.pos.co.zm/Franchise_OnlineServer/";
window.franchiseSpringServerApi =
  "https://overflow.pos.co.zm/FranchiseSpringServer/";

// window.synergy = 'http://self:8081/SynergyApi2/'
// window.ticketApi = `http://DESKTOP-MLFHO91:8080/TicketApp/`
// window.overflowSupApi = `http://localhost:8081/kazang_help_desk/api/v1/`

// window.helpdeskApi = `http://localhost:8083/`

window.synergy = "https://lna.pos.co.zm/SynergyApi/";
window.ticketApi = "https://lna.pos.co.zm/TicketApp/";
window.overflowSupApi = "https://lna.pos.co.zm/KazangHelpDesk/api/v1/";

window.ticketApiV2 = ticketApi;
window.chrilanSubApi = `https://chrilantech.com/LytSoftPosOnline/api/subscription/`;
window.subscriptionApi = `https://overflow.pos.co.zm/SubscriptionManager/api/`;
window.backOfficeTomcatApi = `https://overflow.pos.co.zm/Lyt-SoftBackOfficeApi/`;
window.overflowEmailSupApi = `https://overflow.pos.co.zm/Franchise_OnlineServer/emailrecord`;

window.SearchTicket = ticketApi + `ticket/v2/`;
window.numpyTomcatApi = wareHouseTomcatApiC;
window.wareHouseTomcatApi = wareHouseTomcatApiC;

window.pettyCashApi = "https://lna.abc.co.zm/PettyCashApi/api/v1/";
window.magicApi = wareHouseTomcatApiC + `magic/`;
window.navTomcatApi = wareHouseTomcatApiC + `nav/`;

window.responses = responses;
window.errorHandler = errorHandler;

const EventBus = new Vue();
window.EventBus = EventBus;

window.log = (val) => console.log(val);
window.Swal = Swal;

window.generateUUID = () => {
  let uuid = "",
    i,
    random;
  for (i = 0; i < 32; i++) {
    random = (Math.random() * 16) | 0;
    if (i === 8 || i === 12 || i === 16 || i === 20) {
      uuid += "-";
    }
    uuid += (i === 12 ? 4 : i === 16 ? (random & 3) | 8 : random).toString(16);
  }
  return uuid;
};

Vue.prototype.$utils = utils;
window.$utils = utils;

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 1500,
  showCloseButton: true,
  customClass: "toastr",
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});
window.Toast = Toast;
window.stringify = (object) => queryStringify(object);
window.openUrl = (url, target = "_blank") => window.open(url, target);
window.dateTimeManager = TimeManager;
Vue.prototype.$dateTimeManager = TimeManager;

window.pageOptions = {
  enabled: true,
  mode: "pages",
  perPage: 10,
  position: "bottom",
  perPageDropdown: [10, 100, 200],
  dropdownAllowAll: false,
  jumpFirstOrLast: true,
  pageLabel: "page",
};

// Attach the JWT issued by TicketApp's /user/verifyOtp to every outgoing axios
// request. Mirrors the pattern in the main Help-Desk project so the kazang
// frontend can authenticate against TicketApp's workflow endpoints (which now
// require a Bearer token since the SYN-22 cutover).
axios.interceptors.request.use(async (config) => {
  const requestUrl = String(config?.url || "");
  // Cloudinary rejects unknown Authorization headers on unsigned uploads.
  if (
    requestUrl.includes("api.cloudinary.com") ||
    requestUrl.includes("res.cloudinary.com") ||
    !requestUrl.includes("TicketApp")
  ) {
    return config;
  }

  let tokenState;
  try {
    tokenState = await Storage.getAccessTokenDetails();
  } catch {
    tokenState = { token: null, expiresAt: null, expired: false };
  }
  if (tokenState.expired) {
    try {
      await Storage.clearAccessToken();
    } catch {
      /* ignore */
    }
    return config;
  }
  if (tokenState.token) {
    config.headers = config.headers || {};
    if (typeof config.headers.set === "function") {
      config.headers.set("Authorization", `Bearer ${tokenState.token}`);
    } else {
      config.headers.Authorization = `Bearer ${tokenState.token}`;
    }
  }
  return config;
});

// On 401, explode the stored token so the next request forces re-auth.
// The user is already on /subs; clearing local state is enough — the next
// protected call will be rejected and the user can re-login manually.
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      try {
        await Storage.clearAccessToken();
      } catch {
        /* ignore */
      }
    }
    return Promise.reject(error);
  },
);
window.headers = {
  "Api-Key": "c19bd901-38b8-11ef-91fc-bc2411dbd9df",
};

// Usage Tracker setup
window.synergy7 = window.synergy;
const APPS_ENDPOINT = window.synergy + "api/v1/usage/apps";
const USAGE_ENDPOINT = window.synergy + "api/v1/usage/record";
const BATCH_ENDPOINT = window.synergy + "api/v1/usage/record/batch";
const APP_KEY = "kazang-help-desk-1777981825849";

let appKey = APP_KEY;
let eventQueue = [];
let batchTimeout = null;
const BATCH_DELAY = 2000;

async function fetchHelpDeskAppKey() {
  try {
    const resp = await fetch(APPS_ENDPOINT);
    const apps = await resp.json();
    // Try exact match first, then fall back to any help-desk variant
    let match = apps.find((a) => a.app_key === APP_KEY);
    if (!match) {
      match = apps.find((a) => a.app_key === "help-desk");
    }
    if (match) {
      appKey = match.app_key;
      console.log("[UsageTracker] App key resolved:", appKey);
    }
  } catch (err) {
    console.warn(
      "[UsageTracker] Could not fetch app key, using default:",
      APP_KEY,
    );
    appKey = APP_KEY;
  }
}

fetchHelpDeskAppKey();

function getDeviceId() {
  let deviceId = localStorage.getItem("chrilan_device_id");
  if (!deviceId) {
    deviceId =
      "hd_" +
      Math.random().toString(36).substring(2, 15) +
      Date.now().toString(36);
    localStorage.setItem("chrilan_device_id", deviceId);
  }
  return deviceId;
}

function processBatch() {
  if (eventQueue.length === 0) return;
  const batch = [...eventQueue];
  eventQueue = [];
  clearTimeout(batchTimeout);
  batchTimeout = null;

  fetch(BATCH_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(batch),
  }).catch((err) => console.warn("[UsageTracker] Batch failed:", err));
}

function scheduleBatchProcess() {
  if (batchTimeout) clearTimeout(batchTimeout);
  batchTimeout = setTimeout(processBatch, BATCH_DELAY);
}

window.usageTracker = {
  get appKey() {
    return appKey;
  },
  getDeviceId,
  track(options = {}) {
    const payload = {
      app_key: this.appKey,
      user_id: options.userId || window.userId || null,
      device_id: this.getDeviceId(),
      feature: options.feature || null,
      action: options.action || "view",
      customer_id: options.customerId || null,
      store_id: options.storeId || null,
      business_type: options.businessType || null,
    };

    if (options.immediate || options.action === "view") {
      fetch(USAGE_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }).catch((err) => console.warn("[UsageTracker] Failed:", err));
    } else {
      eventQueue.push(payload);
      scheduleBatchProcess();
    }
  },
  flush() {
    if (batchTimeout) {
      clearTimeout(batchTimeout);
      batchTimeout = null;
    }
    processBatch();
  },
};
